import { create } from "zustand";
import ApiService from "../../API/apiService";
import { API_ENDPOINTS } from "../../API/endpoints";
import { handleApiError } from "../../utils/CommonFunctions";

export const useUserSelfStore = create((set) => ({
  userSelfData: null,
  loading: false,
  error: null,

  /**
   * Fetches user details and updates the store.
   * @param {string} userId - ID of the user to fetch data for.
   */
  getUserSelfDetails: async (userId) => {
    set({ loading: true, error: null });

    try {
      // Call the API
      const response = await ApiService.get(
        `${API_ENDPOINTS.getUserById}/${userId}`,
        { skipCancelToken: true }
      );

      // Check response and update state
      if (response.status === 1) {
        set({ userSelfData: response.data.user });
      } else {
        set({ error: "Failed to fetch user details" });
      }
    } catch (err) {
      handleApiError(err);
      set({ error: err.message || "Unknown error" });
    } finally {
      set({ loading: false });
    }
  },
}));

export const useChatUserStore = create((set) => ({
  chatUserData: null,
  loading: false,
  error: null,

  updateChatUserData: (data) => {
    set({ chatUserData: data });
  },
  /**
   * Fetches user details and updates the store.
   * @param {string} userId - ID of the user to fetch data for.
   */
  getChatUserDetails: async (userId) => {
    set({ loading: true, error: null });

    try {
      // Call the API
      const response = await ApiService.get(
        `${API_ENDPOINTS.getUserById}/${userId}`,
        { skipCancelToken: true }
      );

      // Check response and update state
      if (response.status === 1) {
        set({ chatUserData: response.data.user });
      } else {
        set({ error: "Failed to fetch user details" });
      }
    } catch (err) {
      handleApiError(err);
      set({ error: err.message || "Unknown error" });
    } finally {
      set({ loading: false });
      return true;
    }
  },
}));
